// AWS
import { Auth } from 'aws-amplify'
import { CognitoUser, CognitoUserPool } from 'amazon-cognito-identity-js'
// store
import store from '@/store'
// axios
import axios from 'axios'
// Config environments
import { config } from '@/config'
// Apollo
import { apolloClient } from '@/vue-apollo'
import gql from 'graphql-tag'

export default class AuthService {
  _headers = {
    mode: 'no-cors',
    headers: {
      'Access-Control-Allow-Origin': '*',
      'Access-Control-Allow-Headers': '*',
      'Access-Control-Allow-Methods': 'POST,OPTIONS'
    }
  }

  _cognitoUser
  _user
  _newUser = false

  _pool = new CognitoUserPool({
    UserPoolId: config.userPoolId,
    ClientId: config.userPoolWebClientId
  })

  async signIn (phone, profile, resend = false) {
    let obj = {
      username: phone,
      profile: profile
    }

    try {
      if (resend) {
        await axios.post(`${config.redis}/${phone}`, JSON.stringify({ resend: true }))
      }

      let res = await axios.post(config.signIn, obj, this._headers)

      this._user = res.data.user

      this._cognitoUser = new CognitoUser({ Username: res.data.user.phone, Pool: this._pool })
      this._cognitoUser.Session = res.data.auth.Session

      return true
    } catch (error) {
      let res = { error }

      if (res.error.response.data.message === 'Error: the profile must have a valid phone address as the username. Containing DDIDDDPhoneNumber') return false
      else if (res.error.response.data.message === 'Error: user does not exists.') return this.createAccount(phone, profile)
      else throw error
    }
  }

  async responseAuthChallenge (code) {
    try {
      this._cognitoUser.setAuthenticationFlowType('CUSTOM_AUTH')
      this._cognitoUser = await Auth.sendCustomChallengeAnswer(this._cognitoUser, code)

      let execInfocratics = async () => {
        window.analytics.identify(this._user.id, { name: this._user.name, phone: this._user.phone, email: this._user.email })
        window.analytics.track('Sign In', { name: this._user.name, phone: this._user.phone, email: this._user.email })
      }
      if (process.env.VUE_APP_INFOCRATICS_INTEGRARION) {
        await execInfocratics()
      }

      if (this._cognitoUser.signInUserSession) {
        if (!this._user.name && !this._user.email) {
          await this.updateUserAttributes(this._user.name, this._user.email)
        }
        store.dispatch('setUser', this._user)

        if (this._newUser) return 'new User'
        else return true
      } else return false
    } catch (error) {
      throw error
    }
  }

  async createAccount (phone, profile) {
    let obj = {
      username: phone,
      profile: profile
    }

    this._newUser = true

    try {
      let resp = await axios.post(config.signUp, obj, this._headers)
      let execInfocratics = async () => {
        window.analytics.identify(resp.data.id, { name: resp.data.name, phone: resp.data.phone, email: resp.data.email })
        window.analytics.track('Sign Up', { name: resp.data.name, phone: resp.data.phone, email: resp.data.email })
      }
      if (process.env.VUE_APP_INFOCRATICS_INTEGRARION) {
        await execInfocratics()
      }
      return this.signIn(phone, profile)
    } catch (err) {
      throw err
    }
  }

  async updateUserAttributes (name, email) {
    if (name || email) {
      await Auth.updateUserAttributes(this._cognitoUser, {
        name: name || ``,
        email: email || ``
      })

      let execInfocratics = async () => {
        window.analytics.identify(this._user.id || this._user.sub, { name: name, phone: this._user.phone, email: email })
      }

      if (process.env.VUE_APP_INFOCRATICS_INTEGRARION) {
        await execInfocratics()
      }

      await apolloClient.mutate({
        mutation: gql`mutation updateUserAttributes($phone: String, $name: String, $email: String) {
          update_users(
            where: {
              phone: {
                _eq: $phone
              }
            },
            _set: {
              name: $name,
              email: $email
            }
          ) {
            affected_rows
          }
        }`,
        variables: {
          phone: this._user.phone,
          name,
          email
        }
      })
    }
  }

  async signOut () {
    let execInfocratics = async () => {
      let user = await Auth.currentUserInfo()
      window.analytics.identify(user.attributes.sub, { name: user.attributes.name, phone: user.attributes.phone, email: user.attributes.email })
      window.analytics.track('Sign out', { name: user.attributes.name, phone: user.attributes.phone, email: user.attributes.email })
      window.analytics.reset()
    }

    if (process.env.VUE_APP_INFOCRATICS_INTEGRARION) {
      await execInfocratics()
    }
    await Auth.signOut()
  }

  async isAuthenticated () {
    try {
      await Auth.currentSession()
      return true
    } catch {
      return false
    }
  }

  async verifyUserExists (id, phone, profile) {
    let obj = {
      id,
      phone,
      profile
    }

    try {
      let data = await axios.post(config.verifyUserExistsURL, obj, this._headers)

      return data
    } catch (error) {
      return error
    }
  }
}
